var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-table-cell-content"},[_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content)),_vm._t("content")],2),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTooltip),expression:"showTooltip"}],staticClass:"detail-tooltip"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }